import { TokenHistoryLabel } from "kadow-jetpack-model";
import { isSupportedCTA } from "./isSupportedCTA";

export const SUPPORTED_CTAS = Object.values(TokenHistoryLabel).filter((val) =>
  isSupportedCTA(val)
);
